import {useEffect, useMemo} from 'react';
import {type IAsset} from '../schema';
import {assetJwtStore, getAssetJwtMapIndex} from '../lib/assetJwt';
import {getAllAssetImageUrls} from '../utils/getAllAssetImageUrls';
import {RequireAtLeastOne} from 'type-fest';

// TODO: cleanup and document

export const useAssetImage = (
	asset?: Pick<IAsset, 'assetId' | 'jwt' | 'moddate'> &
		RequireAtLeastOne<Pick<IAsset, 'previewUrl' | 'thumbUrl' | 'zoomUrl'>>,
	queryParams?: Record<string | number, string | number>,
) => {
	useEffect(() => {
		if (!asset || !asset.jwt) return;
		assetJwtStore.getState().add([asset]);
		return () => {
			assetJwtStore.getState().remove([asset.assetId]);
		};
	}, [asset?.assetId, asset?.jwt]);

	const jwt =
		assetJwtStore.getState().items[getAssetJwtMapIndex(asset?.assetId ?? 0)];

	const _asset = useMemo(
		() =>
			asset
				? {
						...asset,
						jwt: jwt || asset?.jwt,
					}
				: undefined,
		[
			asset?.jwt,
			asset?.previewUrl,
			asset?.thumbUrl,
			asset?.zoomUrl,
			asset?.moddate,
			jwt,
		],
	);

	const imageUrls = useMemo(
		() => getAllAssetImageUrls(_asset, queryParams),
		[_asset, queryParams],
	);

	return imageUrls;
};
